import React, { useState } from "react";
import { BtnPrimary } from "../../../Components/share/buttons/Btn";
import CoustomTable from "../../../Components/share/Table/CoustomTable";
import { Modal } from "../../../Components/share/modal/Modal";
import IdeaModal from "../../../Components/layouts/StudentCourse/IdeaModal";

function Priority() {
    const [modalbtn, setModalbtn] = useState(false);

    return (
        <div>
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    لیست اولویت های من
                </h4>
            </div>
            <CoustomTable
                list={list}
                showModal={setModalbtn}
                header={header}
                lightbtn={true}
                num={2}
            >
                <Modal show={modalbtn}>
                    <IdeaModal close={setModalbtn} />
                </Modal>
            </CoustomTable>
        </div>
    );
}

export default Priority;
const header = [
    { title: "نام ایده پرداز" },
    { title: "موضوع" },
    { title: "اولویت" },
];
const list = [
    {
        id: 1,
        name: "علی رجبی",
        date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        test: "رمینا",
        btn: "مشاهده کامل ایده",
    },
    {
        id: 2,
        name: "علی رجبی",
        date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        test: "رمینا",
        btn: "مشاهده کامل ایده",
    },
    {
        id: 3,
        name: "علی رجبی",
        date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        test: "شپنا",
        btn: "مشاهده کامل ایده",
    },
    {
        id: 4,
        name: "علی رجبی",
        date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        test: "شپنا",
        btn: "مشاهده کامل ایده",
    },
    {
        id: 5,
        name: "علی رجبی",
        date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        test: "شپنا",
        btn: "مشاهده کامل ایده",
    },
    {
        id: 6,
        name: "علی رجبی",
        date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        test: "شپنا",
        btn: "مشاهده کامل ایده",
    },
];
